import { render, staticRenderFns } from "./negativar.vue?vue&type=template&id=074e388c"
import script from "./negativar.vue?vue&type=script&lang=js"
export * from "./negativar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports